import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PartyState, Translatable, VoterEntityState } from '../../_generatedTypes.g';
import { suggestCode } from '../../Election';
import { UnknownAction, Dispatch } from 'redux';
import { SaveChangesResult } from '../../components/ui/InlineFormItem';
import { voterEntityStateRefreshed } from '../../features/innerState/innerStateSlice';
import { ReadAs, api } from '../../api';

export const makeNextParty = (electionId: number, electionScreen: ElectionScreenState, parties : PartyState[], token: string, dispatch: Dispatch<UnknownAction>): Promise<boolean> => {
    const blueprint = electionScreen;
    let party = {
        Name: blueprint.nextName,
        Code: blueprint.nextCode,
        electionId: electionId,
        ListOrder: blueprint.nextListOrder,
    };
    return pushNewPartyToServer(party, token, dispatch).then(result => {
        if (result.success) {
            editNextPartyName({ NL: '', EN: '' }, electionScreen, parties, dispatch);
            dispatch(nextPartyCodeSet({ code: '', isManual: false }));
            return true;
        }
        return false;
    });
};

export const editNextPartyName = (name: Partial<Translatable>, electionScreen: ElectionScreenState, parties : PartyState[], dispatch: Dispatch<UnknownAction>) => {
    dispatch(nextPartyNameEdited(name));

    const nextName = electionScreen.nextName;
    if (!electionScreen.isNextCodeCustom) {
        const code = suggestCode(nextName, parties.map(x => x.Code));
        dispatch(nextPartyCodeSet({ code: code, isManual: false }));
    }
};

export const pushNewPartyToServer = async (party: Partial<PartyState> & { Code: string }, token: string, dispatch: Dispatch<UnknownAction>): Promise<SaveChangesResult> => {
        return await api(token).Parties.Add<SaveChangesResult>(party)
            .ok((fullFreshEntityState: VoterEntityState) => {
                dispatch(voterEntityStateRefreshed(fullFreshEntityState));
                return { success: true };
            }, ReadAs.Json)
            .anyStatus(errors => {
                dispatch(newPartyErrorsSet(errors));
                return { success: false, errors };
            }, ReadAs.ValidationErrors)
            .fail(() => ({ success: false, errors: [] }));
}

export interface ElectionScreenState {
    sideMenuVisible: boolean,
    nextName: Translatable,
    nextCode: string,
    isNextCodeCustom: boolean,
    errors?: string[],
    nextListOrder: boolean;
}

const electionScreenSlice = createSlice({
    name: 'SLICE_electionScreen',
    initialState: {
        sideMenuVisible: false,
        nextName: { EN: '', NL: '' },
        nextCode: '',
        isNextCodeCustom: false,
        nextListOrder: true,
    } as ElectionScreenState,
    reducers: {
        nextPartyNameEdited(state, action: PayloadAction<Partial<Translatable>>) {
           state.nextName = { NL: state.nextName.NL, EN: state.nextName.EN, ...action.payload }
        },
        createPartySidePanelToggled(state, action: PayloadAction<undefined>) {
            state.sideMenuVisible = !state.sideMenuVisible;
        },
        nextPartyCodeSet(state, action: PayloadAction<{ code: string, isManual: boolean }>) {
            state.nextCode = action.payload.code;
            state.isNextCodeCustom = action.payload.isManual;
        },
        newPartyErrorsSet(state, action: PayloadAction<string[]>) {
            state.errors = action.payload;
        },
        newPartyListOrderSet(state, action: PayloadAction<boolean>) {
            state.nextListOrder = action.payload;
        },
    },
})

export const {
    nextPartyNameEdited,
    createPartySidePanelToggled,
    nextPartyCodeSet,
    newPartyErrorsSet,
    newPartyListOrderSet,
} = electionScreenSlice.actions

export default electionScreenSlice.reducer
